import { observer } from 'mobx-react';
import { SubmittingError } from '.././Types';
import FlashError from '../../../../../FlashMessage/FlashError';
import { NotTranslated, T } from '../../../../../../Translations';

interface Props {
  state: SubmittingError;
}

function SubmittingErrorView({ state }: Props) {
  return (
    <FlashError>
      <T kind="Error submitting form." /> <NotTranslated text={state.error.kind} />
    </FlashError>
  );
}

export default observer(SubmittingErrorView);
